import { AdjustmentJobsActionTypes } from './constants';

type AdjustmentJobsAction = { type: string, payload: {} | string };

export const launchAdjustmentJob = (integrationId): AdjustmentJobsAction => ({
    type: AdjustmentJobsActionTypes.LAUNCH_ADJUSTMENT_JOB,
    payload: { integrationId },
});

export const createAndLaunchAdjustmentJob = (integrationId): AdjustmentJobsAction => ({
    type: AdjustmentJobsActionTypes.CREATE_AND_LAUNCH_ADJUSTMENT_JOB,
    payload: { integrationId },
});

export const adjustmentJobsApiResponseSuccess = (actionType: string, data: any): AdjustmentJobsAction => ({
    type: AdjustmentJobsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const adjustmentJobsApiResponseError = (actionType: string, error: string): AdjustmentJobsAction => ({
    type: AdjustmentJobsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getAdjustmentJobStatus = (integrationId): AdjustmentJobsAction => ({
    type: AdjustmentJobsActionTypes.GET_ADJUSTMENT_JOB_STATUS,
    payload: { integrationId },
});

export const stopAdjustmentJob = (integrationId): AdjustmentJobsAction => ({
    type: AdjustmentJobsActionTypes.STOP_ADJUSTMENT_JOB,
    payload: { integrationId },
});

export const restartAdjustmentJob = (integrationId): AdjustmentJobsAction => ({
    type: AdjustmentJobsActionTypes.RESTART_ADJUSTMENT_JOB,
    payload: { integrationId },
});

export const getAllAdjustmentJobs = (): AdjustmentJobsAction => ({
    type: AdjustmentJobsActionTypes.GET_ALL_ADJUSTMENT_JOBS,
    payload: {},
});
